import axios from "axios";
import * as d3 from "d3";
import {
    // axisTextDim1,
    inrFormatter,
    responsivefy,
    colonAnnotation,
    numberFormat
    // XaxisAttribute
} from '../functions'

export default function (chart, divId, vizName, filterParam) {

    console.log("Hello Linear")
    var size = chart.axisFontSize;
    var fontSize = size + "px";
    var fontColor = chart.axisFontColor;
    var axisLabelFontSize = chart.axisLabelFontSize + "px";
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName;
    console.log("Before Axios");

    // load the data
    axios.post(url, filterParam).then(res => {
        let data = res.data;
        console.log("Data : ", data);

        data.forEach(function (d) {
            d.metric1 = +d.metric1;
            d.metric2 = +d.metric2;
            d.metric3 = +d.metric3;
            console.log("Metric value ; ",d.metric1);
        });


        // set the ranges
        var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).padding(0.1);
        var y2Scale = Math.max(
            Math.abs(d3.min(data, (d) => d.metric1)),
            Math.abs(d3.max(data, (d) => d.metric1))
        );
        var y1Scale = d3.scaleLinear().domain([-y2Scale, y2Scale]).rangeRound([chart.height, 0]).nice();

        // define the axis
        var x1AxisLabel = d3.axisBottom().scale(x1Scale);
        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat(inrFormatter);


        var div = d3.select(divId)
            .append('div')
            .attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;');

        // add the SVG element
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append("svg")
            .attr("width", chart.width + 2 * chart.margin.left + chart.margin.right)
            .attr("height", chart.height + 5 * chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

        // scale range of the data
        x1Scale.domain(data.map((d) => d.dim1_name));
        y1Scale.domain([Math.min(0, d3.min(data, d => d.metric1)), Math.max(0, d3.max(data, d => d.metric1))]);

        // x axis label
        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + chart.height + ")")
            .call(x1AxisLabel)
            .selectAll("text")
            .style('font-size', axisLabelFontSize)
            .style("text-anchor", "end")
            // .attr("dx", XaxisAttribute)
            // .attr("dy", "-.55em")
            // .attr("transform", "rotate(-25)")
            .attr('dx', '-.8em') // Adjust horizontal spacing
            .attr('dy', '-.15em') // Adjust vertical spacing
            .attr('transform', 'rotate(-45)') // Rotate the labels for better visibility
            .attr('font-size', '13px')
            // .text(axisTextDim1);

        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + chart.margin.bottom + 2 * chart.axisLabelDistance)
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.x1AxisDisplayName);

        // y axis label
        svg.append("g")
            .attr("class", "y axis")
            .call(y1AxisLabel)
            .style("font-size", axisLabelFontSize);

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left + 2)
            .attr('x', 0 - (chart.height / 2) + 120)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.y1AxisDisplayName);

        // Plot points for metric1
        svg.selectAll("circle.metric1")
            .data(data)
            .enter()
            .append("circle")
            .attr("class", "metric1")  // Add a class to distinguish between metrics
            .attr("cx", d => x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2)
            .attr("cy", d => y1Scale(d.metric1))
            .attr("r", 5)
            .attr('fill','green')
            .on("mouseover", function (d) {
                // Tooltip code for metric1
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html("YYYYMM" + colonAnnotation + d.dim1_name
                    + '<br>' + "Total_Sales" + colonAnnotation + numberFormat(d.metric1))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
                console.log("Dim1tool : ", d.dim1_name);
                console.log("Metric1tool : ", d.metric1);
            })
            .on("mouseout", function () {
                div.transition()
                    .duration(500)
                    .style("opacity", 0);
            });

// Plot points for metric2
        svg.selectAll("circle.metric2")
            .data(data)
            .enter()
            .append("circle")
            .attr("class", "metric2")  // Add a class to distinguish between metrics
            .attr("cx", d => x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2)
            .attr("cy", d => y1Scale(d.metric2))  // Use y1Scale for metric2
            .attr("r", 5)
            .attr('fill','blue')  // You can choose a different color for metric2
            .on("mouseover", function (d) {
                // Tooltip code for metric2
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html("YYYYMM" + colonAnnotation + d.dim1_name
                    + '<br>' + "Total_Cost" + colonAnnotation + numberFormat(d.metric2))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
                console.log("Dim1tool : ", d.dim1_name);
                console.log("Metric2tool : ", d.metric2);
            })
            .on("mouseout", function () {
                div.transition()
                    .duration(500)
                    .style("opacity", 0);
            });

// Plot points for metric3
        svg.selectAll("circle.metric3")
            .data(data)
            .enter()
            .append("circle")
            .attr("class", "metric3")  // Add a class to distinguish between metrics
            .attr("cx", d => x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2)
            .attr("cy", d => y1Scale(d.metric3))  // Use y1Scale for metric3
            .attr("r", 5)
            .attr('fill','red')  // You can choose a different color for metric3
            .on("mouseover", function (d) {
                // Tooltip code for metric3
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html("YYYYMM" + colonAnnotation + d.dim1_name
                    + '<br>' + "Margin" + colonAnnotation + numberFormat(d.metric3))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
                console.log("Dim1tool : ", d.dim1_name);
                console.log("Metric3tool : ", d.metric3);
            })
            .on("mouseout", function () {
                div.transition()
                    .duration(500)
                    .style("opacity", 0);
            });


        // // Add linear regression line
        // var regressionLine = d3.line()
        //     .x(d => x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2)
        //     .y(d => y1Scale(d.metric1));
        //
        // svg.append("path")
        //     .datum(data)
        //     .attr("class", "regression-line")
        //     .attr("d", regressionLine);

        // Define a linear regression function
        function linearRegression(x, y) {
            //calculating the number of x-axis values are available
            const n = x.length;

            //Sum of x values
            const sumX = x.reduce((acc, val) => acc + val, 0);
            //Sum of y values
            const sumY = y.reduce((acc, val) => acc + val, 0);
            //Product of x and y values
            const sumXY = x.reduce((acc, val, i) => acc + val * y[i], 0);
            //Squared of x values
            const sumX2 = x.reduce((acc, val) => acc + val * val, 0);

            //Calculate the slope and intercept of the linear regression line
            const slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX ** 2);
            const intercept = (sumY - slope * sumX) / n;

            return { slope, intercept };
        }

// Extract arrays for metric1, metric2, metric3, and dim1_name
        const xData = data.map(d => x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2);
        const y1Data = data.map(d => y1Scale(d.metric1));
        const y2Data = data.map(d => y1Scale(d.metric2));
        const y3Data = data.map(d => y1Scale(d.metric3));

// Calculate regression parameters
        const regression1 = linearRegression(xData, y1Data);
        const regression2 = linearRegression(xData, y2Data);
        const regression3 = linearRegression(xData, y3Data);

// Create line generators for regression lines
        const lineGenerator1 = d3.line()
            .x((d, i) => xData[i])
            .y(d => regression1.slope * d + regression1.intercept);

        const lineGenerator2 = d3.line()
            .x((d, i) => xData[i])
            .y(d => regression2.slope * d + regression2.intercept);

        const lineGenerator3 = d3.line()
            .x((d, i) => xData[i])
            .y(d => regression3.slope * d + regression3.intercept);

// Append path elements for regression lines
        svg.append("path")
            .datum(xData)
            .attr("class", "regression-line")
            .attr("d", lineGenerator1)
            .style("stroke", "green");

        svg.append("path")
            .datum(xData)
            .attr("class", "regression-line")
            .attr("d", lineGenerator2)
            .style("stroke", "blue");

        svg.append("path")
            .datum(xData)
            .attr("class", "regression-line")
            .attr("d", lineGenerator3)
            .style("stroke", "red");

    })
}






// import axios from "axios";
// import * as d3 from "d3";
// // import regression from "regression";
// import {
//     axisTextDim1,
//     inrFormatter,
//     responsivefy,
//     XaxisAttribute
// } from '../functions'
//
// export default function (chart, divId, vizName, filterParam) {
//
//     var size = chart.axisFontSize;
//     var fontSize = size + "px";
//     var fontColor = chart.axisFontColor;
//     var axisLabelFontSize = chart.axisLabelFontSize + "px";
//     var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName;
//
//     // load the data
//     axios.post(url, filterParam).then(res => {
//         let data = res.data;
//         console.log("Data",data);
//
//         data.forEach(function (d) {
//             d.metric1 = +d.metric1;
//             console.log("Metric value ; ",d.metric1);
//         });
//
//
//         // set the ranges
//         var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).padding(0.1);
//         var y2Scale = Math.max(
//             Math.abs(d3.min(data, (d) => d.metric1)),
//             Math.abs(d3.max(data, (d) => d.metric1))
//         );
//         var y1Scale = d3.scaleLinear().domain([-y2Scale, y2Scale]).rangeRound([chart.height, 0]).nice();
//
//         // define the axis
//         var x1AxisLabel = d3.axisBottom().scale(x1Scale);
//         var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat(inrFormatter);
//
//
//         var div = d3.select(divId)
//             .append('div')
//             .attr('class', 'tooltip')
//             .attr('style', 'position: absolute; opacity: 0;');
//
//         // add the SVG e
//         // lement
//         var svg = d3.select(divId).select("svg").remove();
//         svg = d3.select(divId)
//             .append("svg")
//             .attr("width", chart.width + 2 * chart.margin.left + chart.margin.right)
//             .attr("height", chart.height + 5 * chart.margin.top + chart.margin.bottom)
//             .call(responsivefy)
//             .append("g")
//             .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");
//
//         // scale range of the data
//         x1Scale.domain(data.map((d) => d.dim1_name));
//         y1Scale.domain([Math.min(0, d3.min(data, d => d.metric1)), Math.max(0, d3.max(data, d => d.metric1))]);
//
//         // x axis label
//         svg.append("g")
//             .attr("class", "x axis")
//             .attr("transform", "translate(0," + chart.height + ")")
//             .call(x1AxisLabel)
//             .selectAll("text")
//             .style('font-size', axisLabelFontSize)
//             .style("text-anchor", "start")
//             .attr("dx", XaxisAttribute)
//             .attr("dy", "-.55em")
//             .attr("transform", "rotate(-25)")
//             .text(axisTextDim1);
//
//         svg.append('text')
//             .attr('x', (chart.width / 3))
//             .attr('y', chart.height + chart.margin.bottom + 2 * chart.axisLabelDistance)
//             .style('fill', fontColor)
//             .style('font-size', fontSize)
//             .text(chart.x1AxisDisplayName);
//
//         // y axis label
//         svg.append("g")
//             .attr("class", "y axis")
//             .call(y1AxisLabel)
//             .style("font-size", axisLabelFontSize);
//
//         svg.append('text')
//             .attr('transform', 'rotate(-90)')
//             .attr('y', 0 - chart.margin.left + 2)
//             .attr('x', 0 - (chart.height / 2) + 120)
//             .attr("dy", ".71em")
//             .style("text-anchor", "end")
//             .style('fill', fontColor)
//             .style('font-size', fontSize)
//             .text(chart.y1AxisDisplayName);
//
//         // Add circles with tooltips
//         svg.selectAll("circle")
//             .data(data)
//             .enter()
//             .append("circle")
//             .attr("cx", d => x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2)
//             .attr("cy", d => y1Scale(d.metric1))
//             .attr("r", 5)
//             .on("mouseover", function (d) {
//                 div.transition()
//                     .duration(200)
//                     .style("opacity", .9);
//                 div.html( d.dim1_name + ", " + d.metric1)
//                     .style("left", (d3.event.layerX) + "px")
//                     .style("top", (d3.event.layerY) + "px");
//                 console.log("Dim1tool : ", d.dim1_name);
//                 console.log("Metric1tool : ", d.metric1);
//             })
//             .on("mouseout", function () {
//                 div.transition()
//                     .duration(500)
//                     .style("opacity", 0);
//             });
//
//         // Add linear regression line
//         var regressionLine = d3.line()
//             .x(d => x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2)
//             .y(d => y1Scale(d.metric1));
//
//         svg.append("path")
//             .datum(data)
//             .attr("class", "regression-line")
//             .attr("d", regressionLine);
//
//     })
// }